import { makeImpl } from '../HashSet.esm.js';

/** @internal */
function keySet(self) {
  return makeImpl(self);
}

export { keySet };
